<div class="btn-icon-right btn-with-theme" [ngClass]="theme">
    <button class="btn" mat-button 
    [type]="type" 
    [color]="color" 
    [ngClass]="{'uc': uppercase}" 
    [ngStyle]="{'fontWeight': fontWeight}"
    >
        <div class="btn-icon-text-wrapper">
            {{iconPosition == 'right' ? text : ''}}
            <div class="btn-icon-wrapper">
                <mat-icon class="material-icons-outlined btn-icon" [color]="iconColor">{{icon}}</mat-icon>
            </div>
            {{iconPosition == 'left' ? text : ''}}
        </div>
    </button>
</div>
